// extracted by mini-css-extract-plugin
export var textInput = "_gd-0";